<!-- 角色权限 -->
<template>
    <el-dialog :title="`角色权限(${roleName})`" :modal-append-to-body="false" :visible.sync="visible" :close-on-click-modal="false" width="450px"  v-if="visible">
        <el-tree ref="authTree" :data="menuList" :props="defaultProps" show-checkbox node-key="menuId" default-expand-all :default-checked-keys="chooseMenu" @check="handleCheckChange">
            <span class="custom-tree-node" slot-scope="{ node,data }">
              <span>
                  <i :class="data.menuIco"></i> {{ node.label }}
                  <span v-if="data.menuType == 'menu'" style="color: #0F81FB;">(菜单)</span>
                  <span v-if="data.menuType == 'button'" style="color: #E6A23C;">(按钮)</span>
                  <span v-if="data.menuType == 'auth'" style="color: #47B267;">(授权)</span>
              </span>
            </span>
        </el-tree>
        <div v-if="canManage()" slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="updateRoleMenu">授 权</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "roleAuth",
    data() {
        return {
            visible: false,
            defaultProps: {
                children: 'nodes',
                label: 'menuName'
            },
            menuList: [],
            chooseMenu: [],
            roleName: "",
            operateData: {},
            brandId: "",
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
    },
    methods: {
    	open(roleData){
    		this.roleName = roleData.roleName;
            this.brandId = roleData.brandId;
    		this.auth(roleData);
            this.visible = true;
    	},
        // 显示授权
        auth(param) {
            function getCheckedMenuList(menuList){
                let hasChoose = [];
                function check(menuList){
                    for(let menu of menuList){
                        if(menu.nodes === null){
                            if(menu.isSelect == "1"){
                                hasChoose.push(menu.menuId);
                            }
                        }else{
                            check(menu.nodes);
                        }
                    }
                }
                check(menuList);
                return hasChoose;
            }

            this.$api.getRoleMenuList(param.brandId ? param.brandId : null, param.roleId).then(res => {
                if(res.errcode != 0) return false;
                let menuListSource = res.data
                this.menuList = this.translateDataToTree(menuListSource);

                this.chooseMenu = getCheckedMenuList(this.menuList);
                this.operateData = param
                this.$nextTick(() => {
                    this.$refs.authTree.setCheckedKeys(this.chooseMenu)
                });
            })
        },
        translateDataToTree(arr) {
            let canManage = this.canManage();
            return arr.filter((father) => {
                let branchArr = arr.filter((child) => {
                    if(!canManage) child.disabled = true;
                    return father.menuId == child.parentMenuId
                })
                branchArr.length > 0 ? father.nodes = branchArr : ''
                return father.parentMenuId == ''
            })
        },
        // 授权菜单点击
        handleCheckChange(data, checked) {
            this.operateData.menuList = checked.checkedKeys.concat(checked.halfCheckedKeys);
        },
        // 更改独立授权
        updateRoleMenu() {
            this.$api.roleUpdateMenu({
                ...this.operateData
            }).then(res => {
                if(res.errcode != 0) return false;
                this.$message.success(res.errmsg);
                this.visible = false;
            })
        },
        canManage(){
            return this.userInfo.userType == 1 || (this.userInfo.userType == 2 && !['', null, undefined].includes(this.brandId));
        }
    }
}
</script>